<script setup lang="ts">
import type { THeading } from '~/components/ui/heading/types'

const props = defineProps<{
  tag: THeading
}>()
</script>

<template>
  <component :is="props.tag">
    <slot />
  </component>
</template>
